import {
  ApplicationSubtype,
  AppPageContentWrapper,
  CircularTextLoader,
  PageContentBox,
  THUNK_STATUS,
} from "@duosoftbg/nacid-components";
import { Alert, Box } from "@mui/material";
import React, { useEffect } from "react";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import ServiceStepper from "../common/stepper/ServiceStepper";
import { useTranslation } from "react-i18next";
import { fetchLoggedUserDetails } from "../../../../store/redux/slice/AppData/loggedUser";
import { useSearchParams } from "react-router-dom";
import { fetchSeOfficialNoteForm } from "../../../../store/redux/slice/Forms/seOfficialNoteForm";

const SEOfficialNoteEdit = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const seOfficialNoteForm = useAppSelector((state) => {
    return state.Forms.SEOfficialNoteForm;
  });

  useEffect(() => {
    dispatch(fetchSeOfficialNoteForm(id));
    dispatch(fetchLoggedUserDetails());
  }, [dispatch, id]);

  return (
    <AppPageContentWrapper>
      <PageContentBox>
        <Box sx={{ width: "100%" }}>
          {seOfficialNoteForm.dataStateStatus === THUNK_STATUS.FULFILLED ? (
            <ServiceStepper
              serviceSteps={seOfficialNoteForm.steps}
              applicationSubtype={ApplicationSubtype.SE_RECOGNITION}
            />
          ) : null}
          {seOfficialNoteForm.dataStateStatus === THUNK_STATUS.REJECTED ? (
            <Alert severity={"error"}>{t("m.generic.error.service.fail")}</Alert>
          ) : null}
          {seOfficialNoteForm.dataStateStatus === THUNK_STATUS.PENDING ? <CircularTextLoader /> : null}
        </Box>
      </PageContentBox>
    </AppPageContentWrapper>
  );
};

export default SEOfficialNoteEdit;
